import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "replyInfo", "replyText", "replyId", "photoInput", "textarea", "submit" ]

  connect() {
    if (this.hasTextareaTarget) {
      this.#resizeTextarea()
      this.updateSubmitButton()
      this.textareaTarget.focus()
    }
  }

  reply(event) {
    const button = event.currentTarget
    const id = button.dataset.messageId
    const text = button.dataset.messageText

    this.replyIdTarget.value = id
    this.replyTextTarget.textContent = `Ответ на: ${text}`
    this.replyInfoTarget.classList.remove("hidden")
    if (this.hasTextareaTarget) this.textareaTarget.focus()
  }

  clearReply() {
    this.replyIdTarget.value = ""
    this.replyTextTarget.textContent = ""
    this.replyInfoTarget.classList.add("hidden")
    if (this.hasTextareaTarget) this.textareaTarget.focus()
  }

  pickPhoto() {
    this.photoInputTarget.click()
  }

  resize() {
    this.#resizeTextarea()
  }

  updateSubmitButton() {
    if (!this.hasSubmitTarget) return

    const hasText = this.hasTextareaTarget && this.textareaTarget.value.trim().length > 0
    const hasPhoto = this.hasPhotoInputTarget && this.photoInputTarget.files.length > 0
    this.submitTarget.disabled = !(hasText || hasPhoto)
  }

  photoChanged() {
    this.updateSubmitButton()
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      if (this.hasSubmitTarget && this.submitTarget.disabled) return
      this.element.requestSubmit()
    }
  }

  #resizeTextarea() {
    const textarea = this.textareaTarget
    textarea.style.height = "auto"
    const lineHeight = 24
    const maxHeight = lineHeight * 4
    const newHeight = Math.min(textarea.scrollHeight, maxHeight)
    textarea.style.height = `${newHeight}px`
  }
}
